import client from 'app/client';
import { MandantTunnelChoice } from './mandantTypes';

interface GetMandantsTunnelsResponse {
  mandants: Array<{
    courtierId: string;
    tunnels: MandantTunnelChoice[];
  }>;
}

/**
 * Tunnels habilités actifs par courtier mandant candidat dans les OUs données.
 * Endpoint générique (machinerie MIA partagée avec les PIM).
 */
export async function getMandantsTunnels(
  courtierIds: string[],
  plateformeIds: string[],
): Promise<Record<string, MandantTunnelChoice[]>> {
  const { data } = await client.post<GetMandantsTunnelsResponse>(
    '/backoffice/mias/mandants/tunnels-habilites',
    { courtierIds, plateformeIds },
  );
  return Object.fromEntries(
    (data?.mandants ?? []).map((m) => [m.courtierId, m.tunnels ?? []]),
  );
}
